import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { WcGridModule } from '../../components/wc-grid/wc-grid.module';

@Component({
  selector: 'app-models-unit-set-detail',
  standalone: true,
  templateUrl: './models-unit-set-detail.component.html',
  styleUrls: ['./models-unit-set-detail.component.css'],
  imports: [CommonModule, MatButtonModule, WcGridModule],
})
export class ModelsUnitSetDetailComponent implements OnChanges {
  @Input() unitSetId!: string;
  @Input() unitSetName!: string;
  @Output() back = new EventEmitter<void>();

  gridContext: Record<string, any> = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unitSetId'] && this.unitSetId) {
      this.gridContext = { unitSetId: this.unitSetId };
    }
  }
}
